<template>
  <div class="c-sidebar">
    <n-loader :loading="$var('load')" />
    <div class="sidebar-header">
      <div class="sidebar-title">Панель управления</div>
      <div class="sidebar-divider"></div>
      <div class="company-name">{{ company.title }}</div>
      <div class="company-bin">БИН: {{ company.bin }}</div>
      <div class=""></div>
    </div>


    <div class="sidebar-links">
      <n-link
          class="sidebar-link"
          :to="{ name: 'desktop.orders' }"
          :class="{ active: routeName === 'desktop.orders' }"
      >
        <span class="sidebar-link__text">○&nbsp;&nbsp;Заказы</span>
      </n-link>
      <n-link
          class="sidebar-link"
          :to="{ name: 'desktop.users' }"
          :class="{ active: routeName === 'desktop.users' }"
      >
        <span class="sidebar-link__text">○&nbsp;&nbsp;Пользователи</span>
      </n-link>
      <n-link
          class="sidebar-link"
          :to="{ name: 'desktop.eds' }"
          :class="{ active: routeName === 'desktop.eds' }"
      >
        <span class="sidebar-link__text">○&nbsp;&nbsp;ЭДО / АВР</span>
      </n-link>

      <div class="sidebar-divider"></div>

      <div class="side-bar-logout" @click="$app.auth.logout()">
        <img :src="imgLogout" alt="">
        <span>Выйти</span>
      </div>
    </div>
  </div>
</template>

<script>
import imgLogo from 'assets/logo.png'
import imgFaq from 'assets/sidebar/faq.svg'
import imgStats from 'assets/sidebar/stats.svg'
import imgSupport from 'assets/sidebar/support.svg'
import imgUsers from 'assets/sidebar/users.svg'
import imgFaqActive from 'assets/sidebar/faq-active.svg'
import imgStatsActive from 'assets/sidebar/stats-active.svg'
import imgSupportActive from 'assets/sidebar/support-active.svg'
import imgUsersActive from 'assets/sidebar/users-active.svg'
import imgLogout from 'assets/profile/logout.svg'
import imgTimeTracker from 'assets/mobile-appbar/mobile-time-tracker.svg'
import visits from 'assets/sidebar/visits.svg'
import visitsActive from 'assets/sidebar/visits-active.svg'
import filials from 'assets/sidebar/filial.svg'
import filialsActive from 'assets/sidebar/filial-active.svg'
import documents from 'assets/sidebar/documents.svg'
import documentsActive from 'assets/sidebar/documents-active.svg'
import integrationTab from 'assets/sidebar/documents.svg'
import integrationTabActive from 'assets/sidebar/documents-active.svg'
import historyEntryIcon from 'assets/sidebar/history.svg'
import historyEntryIconActive from 'assets/sidebar/history-active.svg'



export default {
  name: 'CSidebar',
  data() {
    return {
      imgLogo,
      imgStats,
      imgFaq,
      imgSupport,
      imgUsers,
      imgStatsActive,
      imgFaqActive,
      imgSupportActive,
      imgUsersActive,
      imgLogout,
      imgTimeTracker,
      visits,
      visitsActive,
      filials,
      filialsActive,
      documents,
      documentsActive,
      integrationTab,
      integrationTabActive,
      historyEntryIcon,
      historyEntryIconActive,
      company: {},
      needPermanentOtp: false,
      OTP_ALLOWED_BINS: [ "250140028320", "250140028321", "081040013276", "221240009078*", "221240009079" ]
    }
  },
  computed: {
    routeName() {
      return this.$route.name
    },
  },
  watch: {},
  created() {
  },
  mounted() {
    this.loadCompany()
  },
  methods: {
    loadCompany() {
      this.$var('load', true)
      $api.companies.get($app.auth.user().selectedCompany).then((response) => {
        this.company = response.data.content
        this.$store.commit('app/setCompany', this.company)
        this.checkNeedPermanentOtp(this.company.bin)
      }).catch((response) => {
        console.error('An error occurred.');
        $app.ui.notify('Ошибка загрузки компании', 'danger')
        // this.$var('message', $app.secure.clean(response.response.data.message.replace(/\n/g, '<br>')))
      }).finally(() => {
        this.$var('load', false)
      })
    },
    checkNeedPermanentOtp(bin) {
      if (this.OTP_ALLOWED_BINS.includes(bin)) {
        this.needPermanentOtp = true
      }
    }
  },
}
</script>

<style lang="scss" scoped>
.c-sidebar {
  position: fixed;
  inset: 0 auto 0 0;
  width: 240px;
  background: linear-gradient(180deg, #f7f9fc 0%, #eef3f9 100%);
  border-right: 1px solid #e3e8f0;
  z-index: 20;
  overflow-y: auto;

  &::-webkit-scrollbar {
    width: 4px;
  }

  &::-webkit-scrollbar-thumb {
    background: #c7d2e4;
    border-radius: 8px;
  }

  .sidebar-header {
    padding: 26px 18px 18px;
    border-bottom: 1px solid #e3e8f0;
    margin-bottom: 14px;
  }

  .company-name {
    font-weight: 600;
    font-size: 15px;
    color: #2b3445;
  }

  .company-bin {
    font-size: 12px;
    color: #8a97ab;
  }

  .sidebar-title {
    font-size: 18px;
    padding: 4px;
    font-weight: 700;
    color: #1c6ef4;
    letter-spacing: .3px;
  }

  .sidebar-subtitle {
    font-size: 12px;
    color: #8a97ab;
    margin-top: 4px;
  }
}

.sidebar-links {
  padding: 24px 14px;
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.sidebar-link {
  height: 48px;
  padding: 0 16px;
  border-radius: 14px;
  display: flex;
  align-items: center;
  text-decoration: none;
  color: #5b6b82;
  font-weight: 500;
  transition: all .2s ease;

  &:hover {
    background: rgba(28, 110, 244, .08);
    color: #1c6ef4;
  }

  &.active {
    background: linear-gradient(180deg, #1c6ef4 0%, #185adf 100%);
    color: #fff;
    box-shadow: 0 12px 30px rgba(28, 110, 244, .35);
  }
}

.sidebar-link__text {
  font-size: 14px;
  letter-spacing: .2px;
}

.sidebar-divider {
  height: 1px;
  background: #e3e8f0;
  margin: 12px 0;
}

.side-bar-logout {
  margin-top: auto;
  height: 48px;
  padding: 0 16px;
  border-radius: 14px;
  display: flex;
  align-items: center;
  gap: 12px;
  cursor: pointer;
  font-weight: 500;
  color: #d64545;
  background: rgba(214, 69, 69, .08);
  transition: all .2s ease;

  img {
    width: 18px;
    height: 18px;
    opacity: .8;
  }

  &:hover {
    background: rgba(214, 69, 69, .18);
  }
}
</style>
